// ChatWrapper.tsx
import { useChat } from '@app/hooks/useChat';
import { Chat } from 'stream-chat-react';
import { Outlet } from 'react-router-dom';

export function ChatWrapper() {
  const { client } = useChat(); // ✅ safe now

  if (!client) return <Outlet />; // still logging in / bootstrapping

  return (
    <Chat client={client} theme="messaging light">
      <Outlet />
    </Chat>
  );
}
